import React from 'react';

import WorkPosition from './careersPartials/WorkPosition';
import CareersHeader from './careersPartials/CareersHeader';
import OptimizedImage from '../OptimizedImage';

const CareersOffers = ({ reference }) => {
  return (
    <div ref={reference} className="container container-full">
      <OptimizedImage
        src="careers/joinourteam_bg.png"
        background
        className="job-offers"
        style={{
          backgroundPosition: 'top 40px right 32px',
          backgroundSize: '43%'
        }}
      >
        <div className="container">
          <CareersHeader />
          <div className="offers">
            <div className="row">
              <WorkPosition />
            </div>
          </div>
        </div>
      </OptimizedImage>
    </div>
  );
};

export default CareersOffers;
